import axios from "axios";
/**
 * @mixin
 */
export default {
    props: {
        /**
         * Base url for api calls
         */
        // api: {
        //   type: String,
        //   required: true
        // },
        /**
         * Token, by default localstorage: 'const_userToken'
         */
        token: {
            type: String,
            default: () => sessionStorage.getItem("adal.idtoken")
                // default: () => "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IlJFUTBNVVE1TjBOQ1JUSkVNemszTTBVMVJrTkRRMFUwUTBNMVJFRkJSamhETWpkRU5VRkJRZyIsImtleWlkIjoiUkVRME1VUTVOME5DUlRKRU16azNNMFUxUmtORFEwVTBRME0xUkVGQlJqaERNamRFTlVGQlFnIn0.eyJpc3MiOiJodHRwczovL2ZpZG0uZ2lneWEuY29tL2p3dC8zX29TTk1lbzVKcFRLMlNSek9NU2VBU3dtTzk1R3FFcFJTZzd0MHpiU3FDbUJzNVNESDlrd1l3RW1fajhRcEFyODUvIiwiYXBpS2V5IjoiM19vU05NZW81SnBUSzJTUnpPTVNlQVN3bU85NUdxRXBSU2c3dDB6YlNxQ21CczVTREg5a3dZd0VtX2o4UXBBcjg1IiwiaWF0IjoxNTU2NjM5NjExLCJleHAiOjE1NTY2Mzk5MTEsInN1YiI6IjVhMjRmYzUxZTRhMDQwNDU4MDRlOTFjYzU1MzZjNzJhIiwidXNlcm5hbWUiOiJDU1QtVGVzdC1Vc2VyQHByZWtwbWduZXRmci5vbm1pY3Jvc29mdC5jb20iLCJmaXJzdE5hbWUiOiJUZXN0IiwiZW1haWwiOiJDU1QtVGVzdC1Vc2VyQHByZWtwbWduZXRmci5vbm1pY3Jvc29mdC5jb20iLCJkYXRhLmNvbnN0ZWxsYXRpb24iOnsiYWxsQ29tcGFuaWVzIjpbeyJJQlMiOiIxMDAwMjY1MzA4In0seyJJQlMiOiIgMTAwMDIzMjI1NCJ9LHsiSUJTIjoiIDE5OTkwMDU4NjAifSx7IklCUyI6IiAxOTk5MDQ2MTQ4In0seyJJQlMiOiIgMTk5OTAzMjE5MiJ9XSwiaWQiOiJkM2FkZjMzMC05YTJhLTQxMmEtYTA2Ni02ZjgzODFjYjliNjUiLCJlbWFpbCI6IkNTVC1UZXN0LVVzZXJAcHJla3BtZ25ldGZyLm9ubWljcm9zb2Z0LmNvbSJ9fQ.Qhg2dj8KrHcpBQYL2MnUCL3yelG2VenV1WvM8BvTquILspTP0iV_gmITc6K8MJGdQsS7C5eXBZtCDK7O3AzO1eG7VzF2rwAG2ZskTsTRa8VkGByzXPAZ7CM4YARaucRm5H8dlEeTIq-CMFmXxeiKRDAzfxi9CyIkBM9SfXvhJ_lLfjaj4w_ixNs7Mhf8vAslV37zOHmq-ro2MsWyD1ylS4rHprUpsvBSVr-1JJg0sMkAOaFUbO1GYDj4YliYQzotrwExwDhBtIFTHxBptMZXrzUo9_lkvZ5VJ3IftnJddhc9CNyfMfnDo7Jaj04rwnx3y1pEFOxxprXHUzmStDnnwA"
        }
    },
    computed: {
        headers() {
            const token = this.token ? this.token : sessionStorage.getItem("adal.idtoken")
            return {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer " + token
                }
            };
        }
    },
    methods: {
        get(url) {
            // window.console.log('get function')
            return new Promise((resolve, reject) => {
                axios
                    .get(url, this.headers)
                    .then(res => resolve(res))
                    .catch(err => reject(err));
            });
        },
        post(url, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(url, payload, this.headers)
                    .then(res => resolve(res))
                    .catch(err => reject(err));
            });
        },
        delete(url, data) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(url, { data, headers: this.headers.headers })
                    .then(res => resolve(res))
                    .catch(err => reject(err));
            });
        },
        patch(url, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(url, payload, this.headers)
                    .then(res => resolve(res))
                    .catch(err => reject(err));
            });
        }
    }
};